<template>
  <SingleFinderWrapper>
    <button
      v-if="registeredPersonsCount"
      ref="showListPopoverButtonRef"
      class="bg-transparent"
      @click="showListPopover"
    >
      <svg
        class="cursor-pointer z-[10]"
        width="93"
        height="28"
        viewBox="0 0 93 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="93"
          height="28"
          rx="14"
          fill="#009DA6"
        />
        <g clip-path="url(#clip0_39_14)">
          <path
            d="M28.5 13.5C29.6366 13.5 30.7267 13.0522 31.5305 12.2552C32.3342 11.4582 32.7857 10.3772 32.7857 9.25C32.7857 8.12283 32.3342 7.04183 31.5305 6.2448C30.7267 5.44777 29.6366 5 28.5 5C27.3634 5 26.2733 5.44777 25.4695 6.2448C24.6658 7.04183 24.2143 8.12283 24.2143 9.25C24.2143 10.3772 24.6658 11.4582 25.4695 12.2552C26.2733 13.0522 27.3634 13.5 28.5 13.5ZM26.9699 15.0938C23.6719 15.0938 21 17.7434 21 21.0139C21 21.5584 21.4453 22 21.9944 22H35.0056C35.5547 22 36 21.5584 36 21.0139C36 17.7434 33.3281 15.0938 30.0301 15.0938H26.9699Z"
            fill="white"
          />
        </g>
        <text
          x="60%"
          y="52%"
          dominant-baseline="middle"
          text-anchor="middle"
          fill="white"
          font-size="14"
          font-family="Roboto"
        >{{ registeredPersonsCount }} st</text>
        <defs>
          <clipPath id="clip0_39_14">
            <rect
              width="15"
              height="17"
              fill="white"
              transform="translate(21 5)"
            />
          </clipPath>
        </defs>
      </svg>
    </button>
    <div
      v-if="isPopoverActive"
      ref="listPopoverRef"
      v-click-outside="{ fn: () => { isPopoverActive = false }, ignore: '.singlefinders-list-popover' }"
      class="singlefinders-list-popover white-bg shadow-box overflow-visible flex flex-col p-3"
      :class="{ 'singlefinders-list-popover__arrow': popoverHasArrow }"
    >
      <SingleFinderListPopover
        :registered-persons-list="registeredPersonsList"
        @close="onClosePopover"
        @hide-arrow="popoverHasArrow = false"
      />
    </div>
  </SingleFinderWrapper>
</template>

<script setup lang="ts">
import { createPopper, type Instance } from '@popperjs/core'

defineProps({
  tripid: {
    type: String,
    required: true,
  },

  registeredPersonsList: {
    type: Array,
    default: () => [],
  },

  registeredPersonsCount: {
    type: Number,
    default: 0,
  },
})

let popperInstance: null | Instance = null

const showListPopoverButtonRef = ref()
const listPopoverRef = ref()
const isPopoverActive = ref(false)
const popoverHasArrow = ref(true)

const onClosePopover = () => {
  isPopoverActive.value = false
  popoverHasArrow.value = true
}

const showListPopover = () => {
  isPopoverActive.value = true

  nextTick(() => {
    if (popperInstance) {
      popperInstance.destroy()
    }

    if (!showListPopoverButtonRef.value) {
      return
    }

    popperInstance = createPopper(showListPopoverButtonRef.value, listPopoverRef.value, {
      placement: 'auto',
      modifiers: [
        {
          name: 'flip',
          options: {
            allowedAutoPlacements: window.innerWidth > 768 ? ['right', 'left'] : ['bottom', 'top'],
          },
        },
      ],
    })
  })
}
</script>

<style lang="scss">
.singlefinders-list-popover__arrow {
  @media (min-width: theme('screens.md')) {
    &::after {
      background: theme('colors.white');
      box-shadow: -2px 2px 2px 0 rgba(178, 178, 178, 0.2);
      content: "";
      height: 16px;
      width: 16px;
      left: unset;
      right: -16px;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%) rotate(230deg);
    }
  }
}

.singlefinders-list-popover {
  width: 380px;
  z-index: 10;
  @media (min-width: 376px) {
    margin: 16px !important;
  }
}
</style>
